/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrColumnSummaryDescription } from './igr-column-summary-description';
import { ColumnSummaryDescription } from './ColumnSummaryDescription';
import { TypeRegistrar } from "igniteui-react-core";
var IgrColumnSummaryDescriptionModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrColumnSummaryDescriptionModule() {
    }
    IgrColumnSummaryDescriptionModule.register = function () {
        TypeRegistrar.registerCons("IgrColumnSummaryDescription", IgrColumnSummaryDescription);
        TypeRegistrar.register("ColumnSummaryDescription", ColumnSummaryDescription.$type);
    };
    return IgrColumnSummaryDescriptionModule;
}());
export { IgrColumnSummaryDescriptionModule };
//# sourceMappingURL=igr-column-summary-description-module.js.map
